'use client';

import { c as _c } from "react/compiler-runtime";
import { ButtonLink, Icon } from '~/components/primitives';
import { usePortalHREFs } from '../global/portal';
import { useI18n } from '~/features/i18n';
const EmptyCartAlert: React.FC = _props => {
  const $ = _c(22);
  const i18n = useI18n();
  const hrefs = usePortalHREFs();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-16 w-16 items-center justify-center rounded-full bg-blue-100"><Icon name="bag" size="lg" className="text-blue-400" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== i18n) {
    t1 = i18n._("cart.empty.title", undefined, {
      message: "Your cart is empty"
    });
    $[1] = i18n;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <p className="text-lg font-bold text-primary">{t1}</p>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== i18n) {
    t3 = i18n._("cart.empty.description", undefined, {
      message: "Browse our activities and add them to your quote request."
    });
    $[5] = i18n;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className="mt-1 text-sm text-blue-600">{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div>{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== hrefs) {
    t6 = hrefs.PLP();
    $[12] = hrefs;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== i18n) {
    t7 = i18n._("Browse activities");
    $[14] = i18n;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <ButtonLink href={t6} variant="tertiary" size="sm" iconBefore="activity-selection">{t7}</ButtonLink>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t8) {
    t9 = <div data-testid="cart-empty" className="flex flex-col items-center gap-4 rounded-2xl border border-dashed border-blue-200 bg-blue-50/50 py-12 text-center">{t0}{t5}{t8}</div>;
    $[19] = t5;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};
export default EmptyCartAlert;